export function shouldRecreatePreset(props, nextProps) {
  var properties = ['appearance', 'persistScrollGutter', 'allowUndoRedoButtons', 'placeholder', 'sanitizePrivateContent'];
  return properties.reduce(function (acc, curr) {
    return acc || props[curr] !== nextProps[curr];
  }, false);
}